import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Flex } from '@/components/ui';
import { i18nKeys } from '@/i18n/i18nKeyGen';
import { supportsLocalUsbBleConfigurator } from '@/utils/browserCapabilities';

/**
 * 로그인 없이 기기 설정 화면으로 이동하는 버튼.
 * Login/Register 페이지 하단에 공통으로 표시됨.
 * WebUSB/WebBLE를 지원하는 브라우저에서만 렌더링.
 */
export const ConfiguratorButton: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('auth');

  if (!supportsLocalUsbBleConfigurator()) {
    return null;
  }

  return (
    <Button
      type="button"
      variant="tertiaryNeutral"
      width="100%"
      onClick={() => navigate('/configurator/lite')}
      data-tour="device-configurator"
    >
      <Flex direction="row" align="center" gap={5}>
        <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
        <p>{t(i18nKeys.auth.device_configuration_no_login)}</p>
      </Flex>
    </Button>
  );
};
